import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ManageLocaleWrapper = styled.div`
  padding-left: 16px;
  margin-top: 0;
  ${responsive.MOBILE`
    padding-right: 16px;
  `}

  ${responsive.MOBILE`
    padding-left: 8px;
  `}

  .MuiGrid2-container {
    margin-right: 0px;
  }

  .MuiInputBase-adornedEnd {
    background: ${COLORS.cirrus_black1};
  }
`;
